(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["3d"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('elysee-watch-3d')) {
    customElements.define('elysee-watch-3d', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        if (this.wasDisconnected && this.viewer) {
          this.viewer.replaceWith(this.viewer.cloneNode(true));
          this.wasDisconnected = false;
        }
        this.viewer = this.querySelector('model-viewer');
        if (!this.viewer) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.rotateButton = this.querySelector('[data-watch-rotate]');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.rotating = this.dataset.rotate === 'true' && !this.motion.matches;
        this.syncRotation();
        this.clockVisible = false;
        this.clockReady = false;
        this.viewer.addEventListener('load', () => this.prepareClock(), options);
        document.addEventListener('visibilitychange', () => this.refreshClock(), options);
        if (this.viewer.loaded) this.prepareClock();
        this.rotateButton?.addEventListener('click', () => { this.rotating = !this.rotating; this.syncRotation(); }, options);
        this.querySelector('[data-watch-reset]')?.addEventListener('click', () => {
          this.viewer.cameraOrbit = '20deg 78deg 105%';
          this.viewer.cameraTarget = 'auto auto auto';
          this.viewer.resetTurntableRotation?.();
        }, options);
        this.viewer.addEventListener('error', () => this.showError(), options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) { this.rotating = false; this.syncRotation(); }
          this.refreshClock();
        }, options);
        this.observer = new IntersectionObserver(entries => {
          this.clockVisible = entries.some(entry => entry.isIntersecting);
          this.refreshClock();
          if (!this.clockVisible || this.loadingRequested) return;
          this.loadingRequested = true;
          if (customElements.get('model-viewer')) return;
          if (window.Shopify?.loadFeatures) {
            window.Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: errors => { if (errors) this.showError(); } }]);
          } else this.showError();
        }, { rootMargin: '200px' });
        this.observer.observe(this);
      }
      async prepareClock() {
        cancelAnimationFrame(this.clockFrame);
        this.clockReady = false;
        if (!this.viewer.availableAnimations?.includes('ELYSEE_Local_Time')) return;
        const controller = this.controller;
        this.viewer.animationCrossfadeDuration = 0;
        this.viewer.animationName = 'ELYSEE_Local_Time';
        this.viewer.pause();
        await this.viewer.updateComplete;
        if (!this.isConnected || controller !== this.controller || controller.signal.aborted) return;
        this.viewer.play();
        this.viewer.pause();
        this.clockReady = true;
        this.refreshClock();
      }
      clockTime() {
        const now = new Date();
        return (now.getHours() % 12) * 3600 + now.getMinutes() * 60 + now.getSeconds()
          + (this.motion.matches ? 0 : now.getMilliseconds() / 1000);
      }
      refreshClock() {
        cancelAnimationFrame(this.clockFrame);
        if (!this.clockReady) return;
        if (this.dataset.liveTime !== 'true') {
          this.viewer.currentTime = 10 * 3600 + 10 * 60 + 38;
          return;
        }
        this.viewer.currentTime = this.clockTime();
        if (!this.clockVisible || document.hidden) return;
        this.clockLastFrame = -Infinity;
        const tick = timestamp => {
          if (timestamp - this.clockLastFrame >= (this.motion.matches ? 1000 : 1000 / 30)) {
            this.viewer.currentTime = this.clockTime();
            this.clockLastFrame = timestamp;
          }
          this.clockFrame = requestAnimationFrame(tick);
        };
        this.clockFrame = requestAnimationFrame(tick);
      }
      syncRotation() {
        this.viewer.toggleAttribute('auto-rotate', this.rotating);
        this.rotateButton?.setAttribute('aria-pressed', String(this.rotating));
      }
      showError() { const message = this.querySelector('.elysee-watch-3d__error'); if (message) message.hidden = false; }
      disconnectedCallback() {
        this.wasDisconnected = true;
        cancelAnimationFrame(this.clockFrame);
        this.clockReady = false;
        this.loadingRequested = false;
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elysee-interactive-watch"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('elysee-experience')) return;
  let componentReady;
  const loadViewer = () => {
    if (customElements.get('model-viewer')) return Promise.resolve();
    if (componentReady) return componentReady;
    componentReady = new Promise((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error('viewer-timeout')), 20000);
      customElements.whenDefined('model-viewer').then(() => { clearTimeout(timer); resolve(); });
      if (window.Shopify?.loadFeatures) {
        window.Shopify.loadFeatures([{name: 'model-viewer', version: '1.12', onLoad: errors => {
          if (errors) { clearTimeout(timer); reject(errors); }
        }}]);
      } else if (!document.querySelector('script[data-elysee-preview-viewer]')) {
        clearTimeout(timer); reject(new Error('viewer-unavailable'));
      }
    }).catch(error => { componentReady = null; throw error; });
    return componentReady;
  };
  customElements.define('elysee-experience', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      if (this.wasDisconnected && this.viewer) {
        this.viewer.replaceWith(this.viewer.cloneNode(true));
        this.wasDisconnected = false;
      }
      this.abort = new AbortController();
      this.viewer = this.querySelector('model-viewer');
      this.video = this.querySelector('video');
      this.status = this.querySelector('[data-status]');
      this.mode = '3d';
      this.visible = true;
      this.started = false;
      this.token = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.listen(this, 'click', event => {
        const button = event.target.closest('button');
        if (!button || button.disabled) return;
        if (button.hasAttribute('data-clip')) this.playClip(button);
        if (button.hasAttribute('data-return')) this.showModel();
        if (button.hasAttribute('data-replay')) this.replay();
        if (button.hasAttribute('data-orbit')) this.orbit(button);
      });
      this.listen(this.video, 'ended', () => { if (this.mode === 'video') this.message(this.dataset.ended); });
      this.listen(this.video, 'playing', () => { if (this.mode !== 'video') return; this.classList.remove('ew-loading'); this.message(''); });
      this.listen(this.video, 'waiting', () => { if (this.mode !== 'video') return; this.classList.add('ew-loading'); this.message(this.dataset.loading); });
      this.listen(this.video, 'error', () => { if (this.mode !== 'video') return; this.classList.remove('ew-loading'); this.message(this.dataset.videoError); });
      this.listen(document, 'visibilitychange', () => { if (document.hidden) this.video.pause(); this.updateMotion(); });
      this.listen(this.motion, 'change', () => this.updateMotion());
      this.listen(this.viewer, 'load', () => {
        clearTimeout(this.modelTimer);
        this.classList.add('ew-ready'); this.classList.remove('ew-loading');
        if (this.mode === '3d') this.message(this.dataset.drag);
        this.updateMotion();
      });
      this.listen(this.viewer, 'error', () => this.modelError());
      this.listen(this.viewer, 'camera-change', event => {
        if (event.detail?.source === 'user-interaction') {
          this.message('');
          this.querySelectorAll('[data-orbit]').forEach(b => b.setAttribute('aria-pressed', 'false'));
        }
      });
      this.listen(this.viewer, 'progress', event => {
        if (this.classList.contains('ew-loading') && !this.classList.contains('ew-ready') && this.mode === '3d') this.message(`${this.dataset.loading} ${Math.round(event.detail.totalProgress * 100)}%`);
      });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (this.visible) this.start(); else this.video.pause();
        this.updateMotion();
      }, {rootMargin: '100px'});
      this.observer.observe(this.querySelector('.ew-stage'));
      this.querySelectorAll('[data-clip]').forEach(button => { button.disabled = !button.dataset.src; });
    }
    listen(target, type, callback) { target.addEventListener(type, callback, {signal:this.abort.signal}); }
    message(text) { this.status.textContent = text || ''; }
    async start() {
      if (this.started) return;
      const controller = this.abort;
      this.started = true;
      if (!this.dataset.model) return this.modelError();
      if (this.mode === '3d') { this.classList.add('ew-loading'); this.message(this.dataset.loading); }
      try {
        await loadViewer();
        if (!this.isConnected || controller !== this.abort || controller.signal.aborted) return;
        if (this.motion.matches) this.viewer.interpolationDecay = 0;
        this.viewer.setAttribute('src', this.dataset.model);
        if (this.dataset.environment) this.viewer.setAttribute('environment-image', this.dataset.environment);
        this.modelTimer = setTimeout(() => { if (!this.viewer.loaded) this.modelError(); }, 45000);
      } catch (_) { if (this.isConnected) this.modelError(); }
    }
    modelError() {
      clearTimeout(this.modelTimer);this.classList.remove('ew-loading');
      if (this.mode === '3d') this.message(this.dataset.modelError);
    }
    updateMotion() {
      if (!this.viewer?.loaded) return;
      if (this.mode === '3d' && this.visible && !document.hidden && !this.motion.matches) {
        if (this.viewer.availableAnimations?.length) this.viewer.play();
      } else this.viewer.pause();
    }
    revealStage() {
      const stage = this.querySelector('.ew-stage');
      const bounds = stage.getBoundingClientRect();
      if (bounds.bottom < innerHeight * .45 || bounds.top > innerHeight * .5) stage.scrollIntoView({behavior:this.motion.matches ? 'instant' : 'smooth', block:'start'});
    }
    async playClip(button) {
      this.revealStage();
      const token = ++this.token;
      this.lastClip = button;
      this.video.pause();
      this.mode = 'video';
      this.video.hidden = false;
      this.querySelector('[data-playback]').hidden = false;
      this.viewer.setAttribute('aria-hidden','true'); this.viewer.setAttribute('inert','');
      this.classList.add('ew-mode-video', 'ew-loading');
      this.message(this.dataset.loading);
      this.querySelectorAll('[data-clip], [data-return]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      this.querySelector('[data-stage-label]').textContent = button.dataset.title;
      if (button.dataset.poster) this.video.poster = button.dataset.poster;
      this.video.src = button.dataset.src;
      this.video.load();
      this.updateMotion();
      try { await this.video.play(); }
      catch (_) { if (token === this.token) { this.classList.remove('ew-loading'); this.message(this.video.error ? this.dataset.videoError : this.dataset.tapPlay); } }
    }
    showModel() {
      this.revealStage();
      this.token++;this.video.pause();this.video.hidden = true;
      this.mode = '3d';this.classList.remove('ew-mode-video','ew-loading');
      this.querySelector('[data-playback]').hidden = true;
      this.viewer.removeAttribute('aria-hidden');this.viewer.removeAttribute('inert');
      this.querySelectorAll('[data-clip]').forEach(b => b.setAttribute('aria-pressed','false'));
      this.querySelectorAll('[data-return]').forEach(b => b.setAttribute('aria-pressed','true'));
      this.querySelector('[data-stage-label]').textContent = this.dataset.viewLabel;
      this.message(this.viewer.loaded ? this.dataset.drag : this.dataset.modelError);
      this.updateMotion();
    }
    replay() {
      this.video.currentTime = 0;
      this.video.play().catch(() => this.message(this.dataset.tapPlay));
    }
    orbit(button) {
      this.viewer.cameraOrbit = button.dataset.orbit;
      this.viewer.cameraTarget = '0m 0m 0m';
      this.querySelectorAll('[data-orbit]').forEach(b => b.setAttribute('aria-pressed',String(b === button)));
    }
    disconnectedCallback() {
      this.wasDisconnected = true;
      this.token++;this.abort?.abort();this.abort = null;
      this.observer?.disconnect();clearTimeout(this.modelTimer);
      this.video?.pause();this.viewer?.pause?.();
    }
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elysee-proof-room"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const controllerKey = 'elyseeProofRoomController';

    if (window[controllerKey]) {
      window[controllerKey].initAll();
      return;
    }

    const sectionState = new WeakMap();
    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
    const smoothstep = (start, end, value) => {
      if (start === end) return value >= end ? 1 : 0;
      const progress = clamp((value - start) / (end - start), 0, 1);
      return progress * progress * (3 - 2 * progress);
    };

    const phaseOpacity = (progress, index, count) => {
      if (count <= 1) return 1;
      const segment = 1 / count;
      const start = index * segment;
      const end = start + segment;
      const fade = segment * 0.28;
      const inValue = smoothstep(start, start + fade, progress);
      const outValue = 1 - smoothstep(end - fade, end, progress);
      return clamp(inValue * outValue, 0, 1);
    };

    const setVariable = (section, name, value) => {
      section.style.setProperty(name, value.toFixed(4));
    };

    const updateSection = (section) => {
      if (!section.isConnected) return;

      const state = sectionState.get(section);
      if (!state || !state.track) return;

      const rect = state.track.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
      const travel = Math.max(state.track.offsetHeight - viewportHeight, 1);
      const raw = clamp(-rect.top / travel, 0, 1);
      const glow = smoothstep(0.02, 0.18, raw) * (1 - smoothstep(0.2, 0.32, raw));
      const darkness = smoothstep(0, 0.18, raw) * (1 - smoothstep(0.84, 0.98, raw));
      const water = smoothstep(0.22, 0.42, raw) * (1 - smoothstep(0.5, 0.64, raw));
      const scratch = smoothstep(0.46, 0.56, raw) * (1 - smoothstep(0.66, 0.74, raw));
      const steel = smoothstep(0.64, 0.78, raw) * (1 - smoothstep(0.86, 0.94, raw));
      const final = smoothstep(0.82, 0.98, raw);

      setVariable(section, '--proof-progress', raw);
      setVariable(section, '--proof-glow', glow);
      setVariable(section, '--proof-darkness', darkness);
      setVariable(section, '--proof-water', water);
      setVariable(section, '--proof-scratch', scratch);
      setVariable(section, '--proof-steel', steel);
      setVariable(section, '--proof-final', final);

      const phases = state.phases;
      const dots = state.dots;
      const count = Math.max(phases.length, 1);
      let activeIndex = Math.min(count - 1, Math.floor(raw * count));

      if (raw >= 0.995) {
        activeIndex = count - 1;
      }

      phases.forEach((phase, index) => {
        const opacity = phaseOpacity(raw, index, count);
        phase.style.opacity = opacity.toFixed(4);
        phase.style.transform = `translate3d(0, ${(1 - opacity) * 12}px, 0)`;
      });

      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activeIndex);
      });
    };

    const requestUpdate = (section) => {
      const state = sectionState.get(section);
      if (!state || state.ticking) return;

      state.ticking = true;
      window.requestAnimationFrame(() => {
        state.ticking = false;
        updateSection(section);
      });
    };

    const initSection = (section) => {
      if (sectionState.has(section)) {
        requestUpdate(section);
        return;
      }

      const track = section.querySelector('.elysee-proof-room__track');
      if (!track) return;

      const state = {
        ticking: false,
        track,
        phases: section.querySelectorAll('[data-proof-phase]'),
        dots: section.querySelectorAll('[data-proof-dot]'),
        resizeObserver: null
      };

      if ('ResizeObserver' in window) {
        state.resizeObserver = new ResizeObserver(() => requestUpdate(section));
        state.resizeObserver.observe(track);
      }

      sectionState.set(section, state);
      requestUpdate(section);
    };

    const initAll = () => {
      document.querySelectorAll('[data-elysee-proof-room]').forEach(initSection);
    };

    const updateAll = () => {
      document.querySelectorAll('[data-elysee-proof-room]').forEach(requestUpdate);
    };

    window.addEventListener('scroll', updateAll, { passive: true });
    document.addEventListener('scroll', updateAll, { passive: true, capture: true });
    window.addEventListener('scrollend', updateAll, { passive: true });
    window.addEventListener('pageshow', updateAll, { passive: true });

    window.addEventListener('resize', () => {
      initAll();
      updateAll();
    }, { passive: true });
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:section:reorder', initAll);
    document.addEventListener('shopify:block:select', initAll);

    window[controllerKey] = { initAll };
    initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elysee-user-guides"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('elysee-user-guides')) {
  customElements.define('elysee-user-guides', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('a[href^="#"]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = document.getElementById(link.hash.slice(1));
        if (!target || !this.contains(target)) return;
        event.preventDefault();
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const lenis = window.__elyseeLenis;
        if (lenis && !lenis.__elyseeMobileDisabled) lenis.scrollTo(target, {offset:-100, immediate:reduced});
        else target.scrollIntoView({behavior:reduced ? 'instant' : 'smooth', block:'start'});
        history.replaceState(null, '', link.hash);
        target.setAttribute('tabindex','-1');
        target.focus({preventScroll:true});
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-video-expand"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const controllerKey = 'heritageScrollVideoExpandController';

    if (window[controllerKey]) {
      window[controllerKey].initAll();
      return;
    }

    const sectionState = new WeakMap();
    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
    const lerp = (start, end, progress) => start + (end - start) * progress;
    const smoothstep = (start, end, value) => {
      if (start === end) return value >= end ? 1 : 0;
      const progress = clamp((value - start) / (end - start), 0, 1);
      return progress * progress * (3 - 2 * progress);
    };

    const readNumber = (value, fallback) => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : fallback;
    };

    const syncVideoSource = (video, hydrate = false) => {
      if (!video) return;
      if (document.fullscreenElement === video || video.webkitDisplayingFullscreen) return;
      const hasMobile = Boolean(video.querySelector('[data-video-device="mobile"]'));
      const device = window.innerWidth < 750 && hasMobile ? 'mobile' : 'desktop';
      if (!hydrate && video.dataset.videoDevice === device) return;
      const wasPlaying = !video.paused && !video.ended;
      video.dataset.videoDevice = device;
      const poster = device === 'mobile' ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      if (poster) video.poster = poster;
      else video.removeAttribute('poster');
      if (!hydrate && video.dataset.scrollVideoHydrated !== 'true') return;
      video.querySelectorAll('[data-scroll-video-src]').forEach((source) => {
        if (source.dataset.videoDevice === device) source.src = source.dataset.scrollVideoSrc;
        else source.removeAttribute('src');
      });
      video.dataset.scrollVideoHydrated = 'true';
      video.load();
      if (wasPlaying) video.play().catch(() => {});
    };

    const hydrateVideo = (video) => {
      if (!video || video.dataset.scrollVideoHydrated === 'true') return;
      syncVideoSource(video, true);
    };

    const updateSection = (section) => {
      if (!section.isConnected) return;
      syncVideoSource(section.querySelector('video'));

      const rect = section.getBoundingClientRect();
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 1;
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
      const isMobile = viewportWidth < 750;
      const startRatio = readNumber(isMobile ? section.dataset.startWidthMobile : section.dataset.startWidthDesktop, isMobile ? 0.92 : 0.72);
      const maxWidth = readNumber(section.dataset.maxWidth, 1480);
      const aspectRatio = Math.max(readNumber(section.dataset.aspectRatio, 1.7777778), 0.3);
      const startRadius = readNumber(section.dataset.startRadius, 0);
      const start = readNumber(section.dataset.expandStart, 0);
      const end = Math.max(readNumber(section.dataset.expandEnd, 0.85), start + 0.01);
      const travel = Math.max(section.offsetHeight - viewportHeight, 1);
      const raw = clamp(-rect.top / travel, 0, 1);
      let zoomRaw = raw;

      if (isMobile) {
        const sectionWrapper = section.closest('.shopify-section');
        const previousTextFill = sectionWrapper?.previousElementSibling?.querySelector('[data-text-fill-section]');

        if (previousTextFill) {
          const textRect = previousTextFill.getBoundingClientRect();
          zoomRaw = clamp(-textRect.top / viewportHeight, 0, 1);
        } else {
          zoomRaw = clamp((viewportHeight - rect.top) / viewportHeight, 0, 1);
        }
      }

      const progress = smoothstep(start, end, zoomRaw);
      let startWidth = Math.min(viewportWidth * startRatio, maxWidth, viewportWidth - 32);
      let startHeight = startWidth / aspectRatio;

      if (startHeight > viewportHeight * 0.78) {
        startHeight = viewportHeight * 0.78;
        startWidth = startHeight * aspectRatio;
      }

      const width = lerp(startWidth, viewportWidth, progress);
      const height = lerp(startHeight, viewportHeight, progress);
      const radius = lerp(startRadius, 0, progress);

      section.style.setProperty('--scroll-video-frame-width', `${width.toFixed(2)}px`);
      section.style.setProperty('--scroll-video-frame-height', `${height.toFixed(2)}px`);
      section.style.setProperty('--scroll-video-radius', `${radius.toFixed(2)}px`);
      section.classList.toggle('is-fullscreen', progress > 0.98);
    };

    const requestUpdate = (section) => {
      const state = sectionState.get(section);
      if (!state || state.ticking) return;

      state.ticking = true;
      window.requestAnimationFrame(() => {
        state.ticking = false;
        updateSection(section);
      });
    };

    const startBackgroundPreview = async (video) => {
      if (!video || video.dataset.scrollVideoPreviewReady === 'true') return;

      video.dataset.scrollVideoPreviewReady = 'true';
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted', 'muted');
      video.setAttribute('playsinline', 'playsinline');
      video.setAttribute('webkit-playsinline', '');
      video.preload = 'metadata';
      hydrateVideo(video);

      try {
        await video.play();
      } catch (error) {
        video.dataset.scrollVideoPreviewReady = 'blocked';
      }
    };

    const syncPlaybackState = (section, video) => {
      const isActive = section.classList.contains('is-video-activated');
      const isPlaying = Boolean(isActive && video && !video.paused && !video.ended);
      const button = section.querySelector('[data-scroll-video-toggle]');

      section.classList.toggle('is-playing', isPlaying);

      if (button) {
        const playLabel = button.querySelector('[data-scroll-video-play-label]');
        const pauseLabel = button.querySelector('[data-scroll-video-pause-label]');
        const label = isPlaying && pauseLabel ? pauseLabel.textContent : playLabel ? playLabel.textContent : '';
        if (label) button.setAttribute('aria-label', label.trim());
      }
    };

    const initPlayback = (section) => {
      const video = section.querySelector('video');
      if (!video) return;

      syncVideoSource(video);
      const startWhenNear = () => startBackgroundPreview(video);
      if ('IntersectionObserver' in window) {
        const previewObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            startWhenNear();
            observer.disconnect();
          });
        }, {
          root: null,
          rootMargin: '360px 0px',
          threshold: 0.01
        });
        previewObserver.observe(section);
      } else {
        const rect = section.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
        if (rect.top < viewportHeight + 360) startWhenNear();
      }

      const button = section.querySelector('[data-scroll-video-toggle]');
      const hasNativeControls = section.dataset.nativeControls === 'true';
      const keepMutedAfterClick = section.dataset.keepMutedAfterClick === 'true';

      section.classList.toggle('has-native-controls', hasNativeControls);

      if (!button || button.dataset.scrollVideoButtonReady === 'true') return;

      const startMobileFullscreen = async () => {
        section.classList.add('is-video-activated');
        hydrateVideo(video);
        video.muted = false;
        video.defaultMuted = false;
        video.volume = 1;
        video.removeAttribute('muted');
        video.controls = true;
        video.playsInline = false;
        video.removeAttribute('playsinline');
        video.removeAttribute('webkit-playsinline');
        const playback = video.play();
        try {
          if (typeof video.webkitEnterFullscreen === 'function') {
            video.webkitEnterFullscreen();
          } else if (typeof video.requestFullscreen === 'function') {
            const fullscreen = video.requestFullscreen();
            fullscreen?.catch(() => {});
          }
        } catch (error) {
          video.controls = true;
        }
        try {
          await playback;
        } catch (error) {
          section.classList.remove('is-playing');
        }
        syncPlaybackState(section, video);
      };

      video.addEventListener('click', () => {
        if (window.innerWidth < 750 && !video.controls) startMobileFullscreen();
      });

      const restoreInlinePlayback = () => {
        video.pause();
        video.muted = true;
        video.defaultMuted = true;
        video.setAttribute('muted', '');
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.controls = hasNativeControls;
        section.classList.remove('is-video-activated', 'is-playing');
        syncPlaybackState(section, video);
      };
      video.addEventListener('webkitendfullscreen', restoreInlinePlayback);
      video.addEventListener('fullscreenchange', () => {
        if (!document.fullscreenElement) restoreInlinePlayback();
      });

      button.dataset.scrollVideoButtonReady = 'true';
      button.addEventListener('click', async () => {
        if (window.innerWidth < 750) {
          await startMobileFullscreen();
          return;
        }
        const wasActivated = section.classList.contains('is-video-activated');
        section.classList.add('is-video-activated');
        hydrateVideo(video);

        if (hasNativeControls) {
          video.setAttribute('controls', 'controls');
        }

        if (!keepMutedAfterClick) {
          video.muted = false;
          video.defaultMuted = false;
          video.removeAttribute('muted');
        }

        if (!wasActivated) {
          try {
            await video.play();
          } catch (error) {
            section.classList.remove('is-playing');
          }

          syncPlaybackState(section, video);
          return;
        }

        if (!video.paused && !video.ended) {
          video.pause();
          syncPlaybackState(section, video);
          return;
        }

        try {
          await video.play();
        } catch (error) {
          section.classList.remove('is-playing');
        }

        syncPlaybackState(section, video);
      });

      video.addEventListener('play', () => syncPlaybackState(section, video));
      video.addEventListener('pause', () => syncPlaybackState(section, video));
      video.addEventListener('ended', () => syncPlaybackState(section, video));
      syncPlaybackState(section, video);
    };

    const initSection = (section) => {
      if (!section) return;

      if (!sectionState.has(section)) {
        const state = { ticking: false };
        sectionState.set(section, state);
        initPlayback(section);
      }

      updateSection(section);
    };

    const initAll = (root = document) => {
      if (root.matches && root.matches('[data-scroll-video-section]')) initSection(root);
      root.querySelectorAll('[data-scroll-video-section]').forEach(initSection);
    };

    const updateAll = () => {
      document.querySelectorAll('[data-scroll-video-section]').forEach(requestUpdate);
    };

    window[controllerKey] = { initAll, updateAll };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    window.addEventListener('scroll', updateAll, { passive: true });
    document.addEventListener('scroll', updateAll, { passive: true, capture: true });
    window.addEventListener('resize', updateAll);
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:select', (event) => {
      initAll(event.target);
      updateAll();
    });

    window.setTimeout(updateAll, 50);
    window.setTimeout(updateAll, 300);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watch-scroll-closeup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-three-state-scroll]';
    const instances = new WeakMap();
    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
    const lerp = (start, end, value) => start + (end - start) * value;
    const finiteNumber = (value, fallback) => {
      if (value === undefined || value === null || value === '') return fallback;
      const number = Number(value);
      return Number.isFinite(number) ? number : fallback;
    };
    const smoothstep = (edge0, edge1, value) => {
      if (edge0 === edge1) return value >= edge1 ? 1 : 0;
      const x = clamp((value - edge0) / (edge1 - edge0), 0, 1);
      return x * x * (3 - 2 * x);
    };
    const easeInOutCubic = (value) => {
      const x = clamp(value, 0, 1);
      return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
    };

    class ThreeStateScroll {
      constructor(root) {
        this.root = root;
        this.sticky = root.querySelector('.heritage-three-state-scroll__sticky');
        this.layout = root.querySelector('.heritage-three-state-scroll__layout');
        this.mediaFrame = root.querySelector('.heritage-three-state-scroll__media');
        this.canvas = root.querySelector('[data-three-state-canvas]');
        this.context = this.canvas ? this.canvas.getContext('2d') : null;
        this.sceneCanvas = null;
        this.sceneContext = null;
        this.blurCanvas = null;
        this.blurContext = null;
        this.imagesElement = root.querySelector('[data-three-state-images]');
        this.media = window.matchMedia('(max-width: 749px)');
        this.desktopMedia = window.matchMedia('(min-width: 990px)');
        this.sources = this.readSources();
        this.images = [];
        this.dateImages = [];
        this.secondHandImages = [];
        this.raf = null;
        this.secondHandRaf = null;
        this.lazyObserver = null;
        this.visibilityObserver = null;
        this.layerLoadHandle = null;
        this.layerLoadHandleType = '';
        this.layerImagesRequested = false;
        this.baseFullLoaders = [];
        this.baseFullRequested = false;
        this.loadToken = 0;
        this.connected = false;
        this.isVisible = true;
        this.lastSecondHandFrame = 0;
        this.scrollTargets = [];
        this.animationStartedAt = performance.now();
        this.lastProgress = 0;
        this.currentBlur = 0;
        this.lastScrollY = 0;
        this.lastTime = performance.now();
        this.lastScrollDrawTime = 0;
        this.blurTimer = null;
        this.activeBlurPlacement = null;
        this.activeBlurSourceWidth = 0;
        this.activeBlurSourceHeight = 0;
        this.stableMobileViewportWidth = 0;
        this.stableMobileViewportHeight = 0;
        this.lastResizeWidth = window.innerWidth || document.documentElement.clientWidth || 1;
        this.onScroll = this.requestUpdate.bind(this);
        this.onResize = this.handleResize.bind(this);
        this.onMediaChange = this.handleResize.bind(this);
        this.onDesktopMediaChange = this.handleResize.bind(this);
      }

      connect() {
        if (this.connected || !this.canvas || !this.context) return;
        this.connected = true;
        this.resizeCanvas();
        this.loadImages();
        this.bindScrollTargets();
        this.lastScrollY = this.getScrollTop();
        this.setupVisibilityObserver();
        this.startSecondHandTicker();
        window.addEventListener('resize', this.onResize);

        if (this.media.addEventListener) {
          this.media.addEventListener('change', this.onMediaChange);
        } else if (this.media.addListener) {
          this.media.addListener(this.onMediaChange);
        }

        if (this.desktopMedia.addEventListener) {
          this.desktopMedia.addEventListener('change', this.onDesktopMediaChange);
        } else if (this.desktopMedia.addListener) {
          this.desktopMedia.addListener(this.onDesktopMediaChange);
        }

        this.requestUpdate();
      }

      disconnect() {
        if (this.lazyObserver) {
          this.lazyObserver.disconnect();
          this.lazyObserver = null;
        }

        if (this.visibilityObserver) {
          this.visibilityObserver.disconnect();
          this.visibilityObserver = null;
        }

        this.cancelLayerLoad();

        if (!this.connected) return;
        this.connected = false;
        this.unbindScrollTargets();
        window.removeEventListener('resize', this.onResize);

        if (this.media.removeEventListener) {
          this.media.removeEventListener('change', this.onMediaChange);
        } else if (this.media.removeListener) {
          this.media.removeListener(this.onMediaChange);
        }

        if (this.desktopMedia.removeEventListener) {
          this.desktopMedia.removeEventListener('change', this.onDesktopMediaChange);
        } else if (this.desktopMedia.removeListener) {
          this.desktopMedia.removeListener(this.onDesktopMediaChange);
        }

        if (this.raf) window.cancelAnimationFrame(this.raf);
        if (this.secondHandRaf) {
          window.cancelAnimationFrame(this.secondHandRaf);
          this.secondHandRaf = null;
        }
        if (this.blurTimer) window.clearTimeout(this.blurTimer);
      }

      cancelLayerLoad() {
        if (!this.layerLoadHandle) return;

        if (this.layerLoadHandleType === 'idle' && window.cancelIdleCallback) {
          window.cancelIdleCallback(this.layerLoadHandle);
        } else {
          window.clearTimeout(this.layerLoadHandle);
        }

        this.layerLoadHandle = null;
        this.layerLoadHandleType = '';
      }

      readSources() {
        try {
          return JSON.parse(this.imagesElement.textContent || '{}');
        } catch (error) {
          return { desktop: [], mobile: [] };
        }
      }

      getActiveSources() {
        const mobile = Array.isArray(this.sources.mobile) ? this.sources.mobile : [];
        const desktop = Array.isArray(this.sources.desktop) ? this.sources.desktop : [];
        const active = this.media.matches ? mobile : desktop;
        const fallback = this.media.matches ? desktop : mobile;
        return [this.pickSource(active[0], fallback[0])];
      }

      getActiveDateSource() {
        const mobile = this.sources.dateMobile || '';
        const desktop = this.sources.dateDesktop || '';
        return this.media.matches ? this.pickSource(mobile, desktop) : this.pickSource(desktop, mobile);
      }

      getActiveSecondHandSource() {
        const mobile = this.sources.secondHandMobile || '';
        const desktop = this.sources.secondHandDesktop || '';
        return this.media.matches ? this.pickSource(mobile, desktop) : this.pickSource(desktop, mobile);
      }

      normalizeSource(source) {
        if (!source) return { preview: '', full: '', width: 0 };

        if (typeof source === 'string') {
          return {
            preview: source,
            full: source,
            width: 0
          };
        }

        const preview = source.preview || source.full || '';
        const full = source.full || source.preview || '';

        return {
          preview,
          full,
          width: finiteNumber(source.width, 0)
        };
      }

      hasSource(source) {
        return Boolean(source && (source.preview || source.full));
      }

      pickSource(primary, fallback) {
        const active = this.normalizeSource(primary);
        if (this.hasSource(active)) return active;

        return this.normalizeSource(fallback);
      }

      loadImages() {
        const token = this.loadToken + 1;
        this.loadToken = token;
        this.cancelLayerLoad();
        this.images = [];
        this.dateImages = [];
        this.secondHandImages = [];
        this.layerImagesRequested = false;
        this.baseFullLoaders = [];
        this.baseFullRequested = false;
        this.root.classList.remove('has-images');
        const sources = this.getActiveSources();
        let loadedCount = 0;

        sources.forEach((source, index) => {
          if (!this.hasSource(source)) return;

          this.loadProgressiveImage(source, token, {
            previewPriority: 'high',
            fullPriority: 'low',
            fullDelay: this.media.matches ? 360 : 180,
            deferFull: true,
            skipFull: this.root.dataset.loadFullResolutionBase !== 'true',
            onLoad: (image, quality) => {
              if (token !== this.loadToken) return;
              const wasEmpty = !this.images[index];

              this.images[index] = image;

              if (wasEmpty) {
                loadedCount += 1;
                if (loadedCount > 0) this.root.classList.add('has-images');
              }

              this.requestUpdate();

              if (quality === 'full') {
                this.startSecondHandTicker();
              }
            }
          }, (loadFull) => {
            this.baseFullLoaders[index] = loadFull;
          });
        });

        this.scheduleLayerImages(token);
      }

      loadProgressiveImage(source, token, options, onFullLoader) {
        const preview = source.preview || source.full;
        const full = source.full || source.preview;
        const hasDistinctFull = Boolean(full && preview && full !== preview);

        if (!preview) return;

        const load = (url, quality, priority, loading) => {
          const image = new Image();
          image.decoding = 'async';
          image.loading = loading;
          image.fetchPriority = priority;
          image._coordinateWidth = source.width || 0;
          image.onload = () => {
            if (token !== this.loadToken) return;
            const apply = () => {
              if (token !== this.loadToken) return;
              options.onLoad(image, quality);
            };

            if (quality === 'full' && image.decode) {
              image.decode().then(apply).catch(apply);
              return;
            }

            apply();
          };
          image.src = url;
        };

        load(preview, 'preview', options.previewPriority || 'high', 'eager');

        if (options.skipFull) return;
        if (!hasDistinctFull) return;

        const loadFull = () => load(full, 'full', options.fullPriority || 'low', 'lazy');

        if (options.deferFull) {
          if (onFullLoader) onFullLoader(loadFull);
          return;
        }

        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(loadFull, { timeout: options.fullDelay || 600 });
          return;
        }

        window.setTimeout(loadFull, options.fullDelay || 180);
      }

      scheduleLayerImages(token) {
        if (token !== this.loadToken) return;
        if (this.layerImagesRequested) return;
        this.layerImagesRequested = true;

        const run = () => {
          this.layerLoadHandle = null;
          this.layerLoadHandleType = '';
          this.loadLayerImages(token);
        };

        this.layerLoadHandleType = 'timeout';
        this.layerLoadHandle = window.setTimeout(run, 0);
      }

      loadLayerImages(token) {
        if (token !== this.loadToken) return;

        const dateSource = this.getActiveDateSource();
        const secondHandSource = this.getActiveSecondHandSource();

        if (this.hasSource(dateSource)) {
          this.loadProgressiveImage(dateSource, token, {
            previewPriority: 'high',
            fullPriority: 'low',
            fullDelay: this.media.matches ? 900 : 360,
            onLoad: (image) => {
              if (token !== this.loadToken) return;
              this.dateImages[0] = image;
              this.requestUpdate();
            }
          });
        }

        if (this.hasSource(secondHandSource)) {
          this.loadProgressiveImage(secondHandSource, token, {
            previewPriority: 'high',
            fullPriority: 'low',
            fullDelay: this.media.matches ? 900 : 360,
            onLoad: (image) => {
              if (token !== this.loadToken) return;
              this.secondHandImages[0] = image;
              this.startSecondHandTicker();
              this.requestUpdate();
            }
          });
        }
      }

      startSecondHandTicker() {
        if (this.secondHandRaf) return;
        if (!this.hasSource(this.getActiveSecondHandSource())) return;
        if (!this.secondHandImages[0]) return;
        if (!this.isVisible) return;

        const tick = (time) => {
          if (!this.connected || !this.isVisible) {
            this.secondHandRaf = null;
            return;
          }

          const frameInterval = this.media.matches ? 50 : 33;
          const recentlyScrollDrawn = this.media.matches && time - this.lastScrollDrawTime < 120;

          if (!recentlyScrollDrawn && time - this.lastSecondHandFrame >= frameInterval) {
            this.lastSecondHandFrame = time;
            if (this.secondHandImages[0] && this.images[0]) this.draw(this.lastProgress);
          }

          this.secondHandRaf = window.requestAnimationFrame(tick);
        };

        this.secondHandRaf = window.requestAnimationFrame(tick);
      }

      resizeCanvas(widthOverride, heightOverride) {
        const width = Math.round(
          widthOverride || Number(this.media.matches ? this.canvas.dataset.mobileWidth : this.canvas.dataset.desktopWidth) || 1920
        );
        const height = Math.round(
          heightOverride || Number(this.media.matches ? this.canvas.dataset.mobileHeight : this.canvas.dataset.desktopHeight) || 1080
        );

        if (this.canvas.width !== width) this.canvas.width = width;
        if (this.canvas.height !== height) this.canvas.height = height;
        [this.sceneCanvas, this.blurCanvas].filter(Boolean).forEach((canvas) => {
          if (canvas.width !== width) canvas.width = width;
          if (canvas.height !== height) canvas.height = height;
        });
      }

      ensureMotionBlurCanvases() {
        if (!this.canvas) return false;

        if (!this.sceneCanvas) {
          this.sceneCanvas = document.createElement('canvas');
          this.sceneContext = this.sceneCanvas.getContext('2d');
        }

        if (!this.blurCanvas) {
          this.blurCanvas = document.createElement('canvas');
          this.blurContext = this.blurCanvas.getContext('2d');
        }

        [this.sceneCanvas, this.blurCanvas].forEach((canvas) => {
          if (canvas.width !== this.canvas.width) canvas.width = this.canvas.width;
          if (canvas.height !== this.canvas.height) canvas.height = this.canvas.height;
        });

        return Boolean(this.sceneContext && this.blurContext);
      }

      releaseMotionBlurCanvases() {
        if (this.sceneCanvas) {
          this.sceneCanvas.width = 0;
          this.sceneCanvas.height = 0;
        }

        if (this.blurCanvas) {
          this.blurCanvas.width = 0;
          this.blurCanvas.height = 0;
        }

        this.sceneCanvas = null;
        this.sceneContext = null;
        this.blurCanvas = null;
        this.blurContext = null;
      }

      handleResize() {
        const width = window.innerWidth || document.documentElement.clientWidth || 1;

        if (this.media.matches && Math.abs(width - this.lastResizeWidth) <= 2) return;
        this.lastResizeWidth = width;

        if (!this.media.matches || Math.abs(width - this.stableMobileViewportWidth) > 2) {
          this.stableMobileViewportWidth = 0;
          this.stableMobileViewportHeight = 0;
        }

        this.resizeCanvas();
        this.loadImages();
        this.bindScrollTargets();
        this.setupVisibilityObserver();
        this.startSecondHandTicker();
        this.requestUpdate();
      }

      setupVisibilityObserver() {
        if (this.visibilityObserver) {
          this.visibilityObserver.disconnect();
          this.visibilityObserver = null;
        }

        if ((window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window)) {
          this.isVisible = true;
          return;
        }

        this.isVisible = false;
        const rootMargin = this.media.matches ? '160px 0px' : '360px 0px';

        this.visibilityObserver = new IntersectionObserver((entries) => {
          const visible = entries.some((entry) => entry.isIntersecting);

          if (this.isVisible === visible) return;
          this.isVisible = visible;

          if (visible) {
            this.requestUpdate();
            this.startSecondHandTicker();
          } else if (this.secondHandRaf) {
            window.cancelAnimationFrame(this.secondHandRaf);
            this.secondHandRaf = null;
          }
        }, { rootMargin });

        this.visibilityObserver.observe(this.root);
      }

      getScrollContainer() {
        let element = this.root.parentElement;

        while (element && element !== document.body) {
          const style = window.getComputedStyle(element);
          const canScroll = /(auto|scroll|overlay)/.test(style.overflowY);

          if (canScroll && element.scrollHeight > element.clientHeight) {
            return element;
          }

          element = element.parentElement;
        }

        if (this.desktopMedia.matches) {
          const pageWrapper = document.querySelector('.page-wrapper');
          if (pageWrapper && pageWrapper.scrollHeight > pageWrapper.clientHeight + 1) {
            return pageWrapper;
          }
        }

        return document.scrollingElement || document.documentElement;
      }

      getScrollTargets() {
        const container = this.getScrollContainer();

        if (container && !this.isDocumentScrollContainer(container)) {
          return [container];
        }

        return [window];
      }

      bindScrollTargets() {
        this.unbindScrollTargets();
        this.scrollTargets = this.getScrollTargets();
        this.scrollTargets.forEach((target) => {
          target.addEventListener('scroll', this.onScroll, { passive: true });
        });
      }

      unbindScrollTargets() {
        this.scrollTargets.forEach((target) => {
          target.removeEventListener('scroll', this.onScroll);
        });
        this.scrollTargets = [];
      }

      isDocumentScrollContainer(container) {
        return container === document.scrollingElement || container === document.documentElement || container === document.body;
      }

      getScrollTop() {
        const container = this.getScrollContainer();

        if (!container || this.isDocumentScrollContainer(container)) {
          return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
        }

        return container.scrollTop || 0;
      }

      getViewportHeight(container) {
        if (this.media.matches && (!container || this.isDocumentScrollContainer(container))) {
          const helper = window.__elyseeMobileViewport;
          if (helper?.active && helper.stageHeight) return helper.stageHeight;

          const width = window.innerWidth || document.documentElement.clientWidth || 1;

          if (!this.stableMobileViewportHeight || Math.abs(width - this.stableMobileViewportWidth) > 2) {
            this.stableMobileViewportWidth = width;
            this.stableMobileViewportHeight = Math.max(320, Math.round(window.innerHeight || document.documentElement.clientHeight || 1));
          }

          return this.stableMobileViewportHeight;
        }

        if (container && !this.isDocumentScrollContainer(container)) {
          return container.clientHeight || window.innerHeight || document.documentElement.clientHeight || 1;
        }

        return window.innerHeight || document.documentElement.clientHeight || 1;
      }

      getScrollViewportTop(container) {
        if (container && !this.isDocumentScrollContainer(container)) {
          return container.getBoundingClientRect().top;
        }

        return 0;
      }

      requestUpdate() {
        if (this.raf) return;
        this.raf = window.requestAnimationFrame(() => {
          this.raf = null;
          this.update();
        });
      }

      update() {
        const scrollContainer = this.getScrollContainer();
        const rect = this.root.getBoundingClientRect();
        const viewportHeight = this.getViewportHeight(scrollContainer);
        const viewportTop = this.getScrollViewportTop(scrollContainer);
        const sectionHeight = Math.max(this.root.offsetHeight, rect.height, viewportHeight + 1);
        const scrollable = Math.max(sectionHeight - viewportHeight, 1);
        const rawProgress = clamp((viewportTop - rect.top) / scrollable, 0, 1);
        const progress = this.applyPhaseHook(rawProgress);
        this.lastProgress = progress;
        this.maybeLoadFullBaseImages(progress, rect, viewportHeight);
        const now = performance.now();
        const scrollY = this.getScrollTop();
        const elapsed = Math.max(now - this.lastTime, 16);
        const velocity = Math.abs(scrollY - this.lastScrollY) / elapsed;
        const maxBlur = finiteNumber(this.root.dataset.motionBlurMax, 0);
        const zoomEnd = finiteNumber(this.root.dataset.zoomEnd, 0.58);
        const zoomStart = finiteNumber(
          this.media.matches ? this.root.dataset.textFadeStartMobile : this.root.dataset.textFadeStartDesktop,
          this.media.matches ? 0.04 : 0.12
        );
        const blurFadeInEnd = Math.min(zoomStart + 0.08, zoomEnd);
        const blurFadeOutStart = Math.max(zoomStart, zoomEnd - 0.12);
        const blurPhase = zoomEnd > zoomStart
          ? smoothstep(zoomStart, blurFadeInEnd, progress) * (1 - smoothstep(blurFadeOutStart, zoomEnd, progress))
          : 0;
        const blur = clamp(velocity * 6.4 * blurPhase, 0, maxBlur);

        this.currentBlur = blur;
        this.root.style.setProperty('--scroll-motion-blur', `${blur.toFixed(2)}px`);
        this.lastScrollY = scrollY;
        this.lastTime = now;

        if (this.blurTimer) {
          window.clearTimeout(this.blurTimer);
          this.blurTimer = null;
        }

        if (blur > 0) {
          this.blurTimer = window.setTimeout(() => {
            this.currentBlur = 0;
            this.root.style.setProperty('--scroll-motion-blur', '0px');
            this.draw(this.lastProgress);
          }, 180);
        } else if (maxBlur <= 0 && (this.sceneCanvas || this.blurCanvas)) {
          this.releaseMotionBlurCanvases();
        }

        this.updateText(progress);
        this.updateMediaFrame(progress);
        this.draw(progress);
        this.lastScrollDrawTime = now;
      }

      maybeLoadFullBaseImages(progress, rect, viewportHeight) {
        if (this.baseFullRequested || !this.baseFullLoaders.length) return;

        const threshold = this.media.matches ? viewportHeight * 0.85 : viewportHeight * 1.1;
        const shouldLoad = progress > 0.01 || rect.top < threshold;

        if (!shouldLoad) return;

        this.baseFullRequested = true;
        this.baseFullLoaders.forEach((loadFull) => {
          if (typeof loadFull === 'function') loadFull();
        });
      }

      applyPhaseHook(progress) {
        if (this.media.matches) return progress;

        const range = finiteNumber(this.root.dataset.phaseHookRange, 0.04);
        const strength = finiteNumber(this.root.dataset.phaseHookStrength, 0.35);

        if (range <= 0 || strength <= 0) return progress;

        const fadeEnd = finiteNumber(
          this.media.matches ? this.root.dataset.textFadeEndMobile : this.root.dataset.textFadeEndDesktop,
          this.media.matches ? 0.24 : 0.3
        );
        const anchors = [
          fadeEnd,
          finiteNumber(this.root.dataset.zoomEnd, 0.58),
          finiteNumber(this.root.dataset.dateSwitchStart, 0.78),
          finiteNumber(this.root.dataset.dateSwitchEnd, 0.88)
        ].filter((anchor) => anchor > 0 && anchor < 1);

        return anchors.reduce((value, anchor) => {
          const distance = Math.abs(value - anchor);
          if (distance >= range) return value;

          const influence = (1 - smoothstep(0, range, distance)) * strength;
          return lerp(value, anchor, influence);
        }, progress);
      }

      updateText(progress) {
        const fadeStart = finiteNumber(
          this.media.matches ? this.root.dataset.textFadeStartMobile : this.root.dataset.textFadeStartDesktop,
          this.media.matches ? 0.04 : 0.12
        );
        const fadeEnd = finiteNumber(
          this.media.matches ? this.root.dataset.textFadeEndMobile : this.root.dataset.textFadeEndDesktop,
          this.media.matches ? 0.24 : 0.3
        );
        const fade = smoothstep(fadeStart, fadeEnd, progress);
        const move = smoothstep(0, fadeEnd, progress);
        const translateY = 50 + (-100 * move);

        this.root.style.setProperty('--scroll-text-opacity', (1 - fade).toFixed(3));
        this.root.style.setProperty('--scroll-text-y', `${translateY.toFixed(2)}px`);
      }

      updateMediaFrame(progress) {
        if (!this.sticky || !this.layout || !this.mediaFrame) return;

        const isMobile = this.media.matches;
        const scrollContainer = this.getScrollContainer();
        const viewportHeight = this.getViewportHeight(scrollContainer);
        const fadeEnd = finiteNumber(
          isMobile ? this.root.dataset.textFadeEndMobile : this.root.dataset.textFadeEndDesktop,
          isMobile ? 0.24 : 0.3
        );
        const fadeStart = finiteNumber(
          isMobile ? this.root.dataset.textFadeStartMobile : this.root.dataset.textFadeStartDesktop,
          isMobile ? 0.04 : 0.12
        );
        const zoomEnd = finiteNumber(this.root.dataset.zoomEnd, 0.58);
        const expandEnd = zoomEnd > fadeStart ? zoomEnd : Math.min(fadeStart + 0.16, 1);
        const expand = smoothstep(fadeStart, expandEnd, progress);
        const layoutStyles = window.getComputedStyle(this.layout);
        const columns = layoutStyles.gridTemplateColumns.split(' ');
        const paddingLeft = finiteNumber(parseFloat(layoutStyles.paddingLeft), 0);
        const paddingRight = finiteNumber(parseFloat(layoutStyles.paddingRight), 0);
        const contentWidth = Math.max(this.layout.clientWidth - paddingLeft - paddingRight, 1);
        const desktopBaseWidth = finiteNumber(parseFloat(columns[0]), this.mediaFrame.offsetWidth || contentWidth);
        const mobileMediaRatio = finiteNumber(this.root.dataset.mobileMediaHeight, 0.48);
        const image = this.images[0];
        const imageRatio = this.getImageMetrics(image).ratio;
        const stableCanvasWidth = Number(this.canvas.dataset.desktopWidth) || 1920;
        const stableCanvasHeight = Math.round(stableCanvasWidth * imageRatio);
        const baseWidth = isMobile ? contentWidth : desktopBaseWidth;
        const baseHeight = isMobile
          ? Math.max(220, viewportHeight * mobileMediaRatio)
          : Math.max(320, baseWidth * imageRatio);
        const fullWidth = this.sticky.clientWidth || this.layout.clientWidth || baseWidth;
        const fullHeight = this.sticky.clientHeight || this.layout.clientHeight || baseHeight;
        const desktopZoomScale = Math.max(1, finiteNumber(this.root.dataset.desktopZoomScale, 1));
        const desktopFocusX = finiteNumber(this.root.dataset.desktopZoomX, 0.5);
        const desktopFocusY = finiteNumber(this.root.dataset.desktopZoomY, 0.5);
        const targetWidth = isMobile ? fullWidth : fullWidth * desktopZoomScale;
        const targetHeight = isMobile ? fullHeight : fullWidth * desktopZoomScale * imageRatio;
        const targetX = isMobile
          ? -((this.layout.offsetLeft || 0) + (this.mediaFrame.offsetLeft || 0))
          : -((this.layout.offsetLeft || 0) + (this.mediaFrame.offsetLeft || 0)) + fullWidth * 0.5 - targetWidth * desktopFocusX;
        const targetY = isMobile
          ? -((this.layout.offsetTop || 0) + (this.mediaFrame.offsetTop || 0))
          : -((this.layout.offsetTop || 0) + (this.mediaFrame.offsetTop || 0)) + fullHeight * 0.5 - targetHeight * desktopFocusY;
        const width = lerp(baseWidth, targetWidth, expand);
        const height = lerp(baseHeight, targetHeight, expand);
        const x = lerp(0, targetX, expand);
        const y = lerp(0, targetY, expand);
        const snap = expand >= 0.995;
        const renderWidth = snap ? Math.round(width) : width;
        const renderHeight = snap ? Math.round(height) : height;
        const renderX = snap ? Math.round(x) : x;
        const renderY = snap ? Math.round(y) : y;

        this.root.style.setProperty('--scroll-media-width', `${renderWidth.toFixed(2)}px`);
        this.root.style.setProperty('--scroll-media-height', `${renderHeight.toFixed(2)}px`);
        this.root.style.setProperty('--scroll-media-x', `${renderX.toFixed(2)}px`);
        this.root.style.setProperty('--scroll-media-y', `${renderY.toFixed(2)}px`);

        if (!isMobile) {
          this.resizeCanvas(stableCanvasWidth, stableCanvasHeight);
        }
      }

      draw(progress) {
        if (finiteNumber(this.currentBlur, 0) > 0 && this.ensureMotionBlurCanvases()) {
          this.withDrawingContext(this.sceneContext, () => this.drawScene(progress));
          this.composeMotionBlur();
          return;
        }

        this.drawScene(progress);
      }

      withDrawingContext(context, callback) {
        const previousContext = this.context;
        this.context = context;

        try {
          callback();
        } finally {
          this.context = previousContext;
        }
      }

      composeMotionBlur() {
        if (!this.sceneCanvas || !this.blurCanvas || !this.blurContext) return;

        const width = this.canvas.width;
        const height = this.canvas.height;
        const blur = finiteNumber(this.currentBlur, 0);

        this.context.clearRect(0, 0, width, height);
        this.context.drawImage(this.sceneCanvas, 0, 0);

        if (!blur || blur <= 0) return;

        const placement = this.activeBlurPlacement;
        const sourceWidth = finiteNumber(this.activeBlurSourceWidth, placement ? placement.sourceWidth : width);
        const sourceBasis = Math.max(1, finiteNumber(this.root.dataset.motionBlurSourceSize, sourceWidth));
        const placementScale = placement ? finiteNumber(placement.width / sourceBasis, 1) : 1;
        const clearDiameter = finiteNumber(this.root.dataset.motionBlurClearDiameter, 1900);
        const fadeWidth = Math.max(1, finiteNumber(this.root.dataset.motionBlurFadeWidth, 260) * placementScale);
        const clearRadius = Math.max(0, (clearDiameter / 2) * placementScale);
        const centerX = placement ? placement.x + placement.width * 0.5 : width / 2;
        const centerY = placement ? placement.y + placement.height * 0.5 : height / 2;
        const gradient = this.blurContext.createRadialGradient(
          centerX,
          centerY,
          clearRadius,
          centerX,
          centerY,
          clearRadius + fadeWidth
        );

        this.blurContext.clearRect(0, 0, width, height);
        this.blurContext.save();
        this.blurContext.filter = `blur(${(blur * 0.55).toFixed(2)}px)`;

        const samples = 9;
        for (let index = 0; index < samples; index += 1) {
          const amount = samples <= 1 ? 0 : index / (samples - 1);
          const scale = 1 + amount * blur * 0.014;
          const sampleWidth = width * scale;
          const sampleHeight = height * scale;

          this.blurContext.globalAlpha = 1 / samples;
          this.blurContext.drawImage(
            this.sceneCanvas,
            centerX - (centerX * scale),
            centerY - (centerY * scale),
            sampleWidth,
            sampleHeight
          );
        }

        this.blurContext.globalAlpha = 1;
        this.blurContext.restore();

        gradient.addColorStop(0, 'rgba(0, 0, 0, 0)');
        gradient.addColorStop(1, 'rgba(0, 0, 0, 1)');

        this.blurContext.save();
        this.blurContext.globalCompositeOperation = 'destination-in';
        this.blurContext.fillStyle = gradient;
        this.blurContext.fillRect(0, 0, width, height);
        this.blurContext.restore();

        this.context.drawImage(this.blurCanvas, 0, 0);
      }

      drawScene(progress) {
        const baseImage = this.images[0];

        if (!baseImage) return;

        const fadeStart = finiteNumber(
          this.media.matches ? this.root.dataset.textFadeStartMobile : this.root.dataset.textFadeStartDesktop,
          this.media.matches ? 0.04 : 0.12
        );
        const holdStateOne = fadeStart;
        const zoomEnd = finiteNumber(this.root.dataset.zoomEnd, 0.58);
        const dateSwitchStart = finiteNumber(this.root.dataset.dateSwitchStart, 0.78);
        const dateSwitchEnd = finiteNumber(this.root.dataset.dateSwitchEnd, 0.88);
        const zoomT = smoothstep(holdStateOne, zoomEnd, progress);
        const dateRaw = dateSwitchStart === dateSwitchEnd
          ? progress >= dateSwitchEnd ? 1 : 0
          : clamp((progress - dateSwitchStart) / (dateSwitchEnd - dateSwitchStart), 0, 1);
        const dateT = easeInOutCubic(dateRaw);
        const scaleTarget = finiteNumber(
          this.media.matches ? this.root.dataset.mobileZoomScale : this.root.dataset.desktopZoomScale,
          this.media.matches ? 3.1 : 2.8
        );
        const focusX = finiteNumber(
          this.media.matches ? this.root.dataset.mobileZoomX : this.root.dataset.desktopZoomX,
          this.media.matches ? 0.5 : 0.39
        );
        const focusY = finiteNumber(
          this.media.matches ? this.root.dataset.mobileZoomY : this.root.dataset.desktopZoomY,
          this.media.matches ? 0.68 : 0.5
        );
        const startPlacement = this.getStartPlacement(baseImage);
        const zoomPlacement = this.getZoomPlacement(baseImage, scaleTarget, focusX, focusY);
        const phaseOnePlacement = startPlacement && zoomPlacement
          ? this.interpolatePlacement(startPlacement, zoomPlacement, zoomT)
          : zoomPlacement;
        const activePlacement = progress >= zoomEnd && zoomPlacement ? zoomPlacement : phaseOnePlacement || zoomPlacement;
        const metrics = this.getImageMetrics(baseImage);

        this.activeBlurPlacement = activePlacement || null;
        this.activeBlurSourceWidth = activePlacement ? activePlacement.sourceWidth || metrics.sourceWidth : metrics.sourceWidth;
        this.activeBlurSourceHeight = activePlacement ? activePlacement.sourceHeight || metrics.sourceHeight : metrics.sourceHeight;

        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);

        if (this.hasDateWindowAnimation()) {
          this.drawDateWindowAnimation(baseImage, dateT, activePlacement);
        }

        this.drawPlacement(baseImage, activePlacement, 1);
        this.drawSecondHand(baseImage, activePlacement);

        if (this.root.dataset.dateGuideEnabled === 'true') {
          this.drawDateWindowGuide(baseImage, activePlacement);
        }

        if (this.root.dataset.animationGuideEnabled === 'true') {
          this.drawAnimationGuide(startPlacement, zoomPlacement);
        }
      }

      drawCover(image, alpha, extraScale, focusX, focusY) {
        if (!image) return;

        const placement = this.getCoverPlacement(image, extraScale, focusX, focusY);
        this.drawPlacement(image, placement, alpha);
      }

      drawPlacement(image, placement, alpha) {
        this.context.save();
        this.context.imageSmoothingEnabled = true;
        this.context.imageSmoothingQuality = 'high';
        this.context.globalAlpha = alpha;
        this.context.drawImage(image, placement.x, placement.y, placement.width, placement.height);
        this.context.restore();
      }

      getImageMetrics(image) {
        const naturalWidth = image ? image.naturalWidth || image.width || 1 : 1;
        const naturalHeight = image ? image.naturalHeight || image.height || 1 : 1;
        const ratio = naturalHeight / naturalWidth;
        const sourceWidth = finiteNumber(image ? image._coordinateWidth : 0, naturalWidth) || naturalWidth;
        const sourceHeight = sourceWidth * ratio;

        return {
          naturalWidth,
          naturalHeight,
          ratio,
          sourceWidth,
          sourceHeight
        };
      }

      getStartPlacement(image) {
        const canvasWidth = this.canvas.width;
        const canvasHeight = this.canvas.height;
        const metrics = this.getImageMetrics(image);
        const widthRatio = finiteNumber(
          this.media.matches ? this.root.dataset.mobileStartWidth : this.root.dataset.desktopStartWidth,
          this.media.matches ? 1.05 : 0.4
        );
        const centerXRatio = finiteNumber(
          this.media.matches ? this.root.dataset.mobileStartX : this.root.dataset.desktopStartX,
          this.media.matches ? 0.5 : 0.3
        );
        const centerYRatio = finiteNumber(
          this.media.matches ? this.root.dataset.mobileStartY : this.root.dataset.desktopStartY,
          this.media.matches ? 0.64 : 0.54
        );
        let width = canvasWidth * widthRatio;
        let height = width * metrics.ratio;
        const containPlacement = this.getContainPlacement(image);

        if (width > containPlacement.width || height > containPlacement.height) {
          width = containPlacement.width;
          height = containPlacement.height;
        }

        const centerX = canvasWidth * centerXRatio;
        const centerY = canvasHeight * centerYRatio;
        const x = width <= canvasWidth ? clamp(centerX - width / 2, 0, canvasWidth - width) : (canvasWidth - width) / 2;
        const y = height <= canvasHeight ? clamp(centerY - height / 2, 0, canvasHeight - height) : (canvasHeight - height) / 2;

        return {
          x,
          y,
          width,
          height,
          scale: width / metrics.sourceWidth,
          sourceWidth: metrics.sourceWidth,
          sourceHeight: metrics.sourceHeight
        };
      }

      getContainPlacement(image) {
        const canvasWidth = this.canvas.width;
        const canvasHeight = this.canvas.height;
        const metrics = this.getImageMetrics(image);
        const scale = Math.min(canvasWidth / metrics.sourceWidth, canvasHeight / metrics.sourceHeight);
        const width = metrics.sourceWidth * scale;
        const height = metrics.sourceHeight * scale;

        return {
          x: (canvasWidth - width) / 2,
          y: (canvasHeight - height) / 2,
          width,
          height,
          scale,
          sourceWidth: metrics.sourceWidth,
          sourceHeight: metrics.sourceHeight
        };
      }

      getZoomPlacement(image, widthRatio, focusX, focusY) {
        const canvasWidth = this.canvas.width;
        const canvasHeight = this.canvas.height;
        const metrics = this.getImageMetrics(image);
        const containPlacement = this.getContainPlacement(image);
        const safeWidthRatio = Math.max(finiteNumber(widthRatio, 1), 1);
        const imageScale = this.media.matches ? safeWidthRatio : 1;
        const width = containPlacement.width * imageScale;
        const height = containPlacement.height * imageScale;
        const minX = canvasWidth - width;
        const minY = canvasHeight - height;
        const maxX = 0;
        const maxY = 0;
        const safeFocusX = finiteNumber(focusX, 0.5);
        const safeFocusY = finiteNumber(focusY, 0.5);
        const x = width <= canvasWidth ? (canvasWidth - width) / 2 : clamp(canvasWidth * 0.5 - width * safeFocusX, minX, maxX);
        const y = height <= canvasHeight ? (canvasHeight - height) / 2 : clamp(canvasHeight * 0.5 - height * safeFocusY, minY, maxY);

        return {
          x,
          y,
          width,
          height,
          scale: width / metrics.sourceWidth,
          sourceWidth: metrics.sourceWidth,
          sourceHeight: metrics.sourceHeight
        };
      }

      interpolatePlacement(start, end, progress) {
        return {
          x: lerp(start.x, end.x, progress),
          y: lerp(start.y, end.y, progress),
          width: lerp(start.width, end.width, progress),
          height: lerp(start.height, end.height, progress),
          scale: lerp(start.scale, end.scale, progress),
          sourceWidth: start.sourceWidth,
          sourceHeight: start.sourceHeight
        };
      }

      getCoverPlacement(image, extraScale, focusX, focusY) {
        const canvasWidth = this.canvas.width;
        const canvasHeight = this.canvas.height;
        const metrics = this.getImageMetrics(image);
        const coverScale = Math.max(canvasWidth / metrics.sourceWidth, canvasHeight / metrics.sourceHeight);
        const scale = coverScale * finiteNumber(extraScale, 1);
        const width = metrics.sourceWidth * scale;
        const height = metrics.sourceHeight * scale;
        const minX = canvasWidth - width;
        const minY = canvasHeight - height;
        const maxX = 0;
        const maxY = 0;
        const safeFocusX = finiteNumber(focusX, 0.5);
        const safeFocusY = finiteNumber(focusY, 0.5);
        const x = clamp(canvasWidth * 0.5 - width * safeFocusX, minX, maxX);
        const y = clamp(canvasHeight * 0.5 - height * safeFocusY, minY, maxY);

        return {
          x,
          y,
          width,
          height,
          scale,
          sourceWidth: metrics.sourceWidth,
          sourceHeight: metrics.sourceHeight
        };
      }

      hasDateWindowAnimation() {
        return Boolean(this.dateImages[0]);
      }

      getDateWindowRect(baseImage, placement) {
        if (!baseImage) return null;
        if (!placement) return null;
        const shape = this.root.dataset.dateWindowShape || 'circle';

        if (shape === 'circle') {
          const centerX = finiteNumber(
            this.media.matches ? this.root.dataset.mobileDateCenterX : this.root.dataset.desktopDateCenterX,
            this.media.matches ? 535 : 713
          );
          const centerY = finiteNumber(
            this.media.matches ? this.root.dataset.mobileDateCenterY : this.root.dataset.desktopDateCenterY,
            this.media.matches ? 1139 : 506
          );
          const radius = finiteNumber(
            this.media.matches ? this.root.dataset.mobileDateRadiusCircle : this.root.dataset.desktopDateRadiusCircle,
            this.media.matches ? 58 : 38
          );

          if (!radius) return null;

          const transformedRadius = radius * placement.scale;
          const transformedCenterX = placement.x + centerX * placement.scale;
          const transformedCenterY = placement.y + centerY * placement.scale;

          return {
            x: transformedCenterX - transformedRadius,
            y: transformedCenterY - transformedRadius,
            width: transformedRadius * 2,
            height: transformedRadius * 2,
            radius: transformedRadius,
            shape: 'circle',
            centerX: transformedCenterX,
            centerY: transformedCenterY,
            sourceCenterX: centerX,
            sourceCenterY: centerY
          };
        }

        const x = finiteNumber(
          this.media.matches ? this.root.dataset.mobileDateX : this.root.dataset.desktopDateX,
          this.media.matches ? 480 : 678
        );
        const y = finiteNumber(
          this.media.matches ? this.root.dataset.mobileDateY : this.root.dataset.desktopDateY,
          this.media.matches ? 1100 : 480
        );
        const width = finiteNumber(
          this.media.matches ? this.root.dataset.mobileDateWidth : this.root.dataset.desktopDateWidth,
          this.media.matches ? 110 : 70
        );
        const height = finiteNumber(
          this.media.matches ? this.root.dataset.mobileDateHeight : this.root.dataset.desktopDateHeight,
          this.media.matches ? 78 : 52
        );
        const radius = finiteNumber(
          this.media.matches ? this.root.dataset.mobileDateRadius : this.root.dataset.desktopDateRadius,
          this.media.matches ? 12 : 8
        );

        if (!width || !height) return null;

        return {
          x: placement.x + x * placement.scale,
          y: placement.y + y * placement.scale,
          width: width * placement.scale,
          height: height * placement.scale,
          radius: radius * placement.scale,
          shape: 'rectangle',
          centerX: placement.x + (x + width / 2) * placement.scale,
          centerY: placement.y + (y + height / 2) * placement.scale,
          sourceCenterX: x + width / 2,
          sourceCenterY: y + height / 2
        };
      }

      drawDateWindowAnimation(baseImage, progress, placement) {
        const dateImage = this.dateImages[0];

        if (!dateImage || !baseImage || !placement) return false;

        const metrics = this.getImageMetrics(baseImage);
        const t = clamp(progress, 0, 1);
        const startRotation = finiteNumber(this.root.dataset.dateRotationStart, 0);
        const endRotation = finiteNumber(this.root.dataset.dateRotationEnd, 18);
        const rotation = lerp(startRotation, endRotation, t);

        this.drawRotatedLayer(dateImage, placement, metrics.sourceWidth / 2, metrics.sourceHeight / 2, rotation, 1);
        return true;
      }

      drawSecondHand(baseImage, placement) {
        const handImage = this.secondHandImages[0];
        if (!handImage || !baseImage || !placement) return;

        const metrics = this.getImageMetrics(baseImage);
        const pivotX = finiteNumber(
          this.media.matches ? this.root.dataset.mobileSecondHandPivotX : this.root.dataset.desktopSecondHandPivotX,
          metrics.sourceWidth / 2
        );
        const pivotY = finiteNumber(
          this.media.matches ? this.root.dataset.mobileSecondHandPivotY : this.root.dataset.desktopSecondHandPivotY,
          metrics.sourceHeight / 2
        );
        const startAngle = finiteNumber(this.root.dataset.secondHandStartAngle, 0);
        const speed = finiteNumber(this.root.dataset.secondHandDegreesPerSecond, 6);
        const elapsed = (performance.now() - this.animationStartedAt) / 1000;
        const angle = startAngle + elapsed * speed;

        this.drawRotatedLayer(handImage, placement, pivotX, pivotY, angle, 1);
      }

      drawDateWindowGuide(baseImage, placement) {
        const rect = this.getDateWindowRect(baseImage, placement);
        if (!rect) return;

        const lineWidth = Number(this.root.dataset.dateGuideWidth) || 2;
        const color = this.root.dataset.dateGuideColor || '#ff2d55';

        this.context.save();
        this.dateWindowPath(rect);
        this.context.strokeStyle = color;
        this.context.lineWidth = lineWidth;
        this.context.setLineDash([lineWidth * 4, lineWidth * 2]);
        this.context.stroke();
        this.context.restore();
      }

      drawAnimationGuide(startPlacement, zoomPlacement) {
        const color = this.root.dataset.animationGuideColor || '#00a3ff';

        this.context.save();
        this.context.strokeStyle = color;
        this.context.lineWidth = 4;
        this.context.setLineDash([20, 10]);

        if (startPlacement) {
          this.context.strokeRect(startPlacement.x, startPlacement.y, startPlacement.width, startPlacement.height);
        }

        if (zoomPlacement) {
          this.context.strokeStyle = '#ff2d55';
          this.context.strokeRect(zoomPlacement.x, zoomPlacement.y, zoomPlacement.width, zoomPlacement.height);
        }

        this.context.restore();
      }

      drawRotatedLayer(image, placement, sourcePivotX, sourcePivotY, degrees, alpha) {
        if (!image || !placement) return;

        const pivotX = placement.x + sourcePivotX * placement.scale;
        const pivotY = placement.y + sourcePivotY * placement.scale;
        const radians = finiteNumber(degrees, 0) * Math.PI / 180;

        this.context.save();
        this.context.globalAlpha = alpha;
        this.context.translate(pivotX, pivotY);
        this.context.rotate(radians);
        this.context.drawImage(
          image,
          placement.x - pivotX,
          placement.y - pivotY,
          placement.width,
          placement.height
        );
        this.context.restore();
      }

      roundRect(x, y, width, height, radius) {
        const r = Math.min(radius || 0, width / 2, height / 2);
        this.context.beginPath();
        this.context.moveTo(x + r, y);
        this.context.lineTo(x + width - r, y);
        this.context.quadraticCurveTo(x + width, y, x + width, y + r);
        this.context.lineTo(x + width, y + height - r);
        this.context.quadraticCurveTo(x + width, y + height, x + width - r, y + height);
        this.context.lineTo(x + r, y + height);
        this.context.quadraticCurveTo(x, y + height, x, y + height - r);
        this.context.lineTo(x, y + r);
        this.context.quadraticCurveTo(x, y, x + r, y);
        this.context.closePath();
      }

      dateWindowPath(rect) {
        if (rect.shape === 'circle') {
          this.context.beginPath();
          this.context.arc(rect.centerX, rect.centerY, rect.radius, 0, Math.PI * 2);
          this.context.closePath();
          return;
        }

        this.roundRect(rect.x, rect.y, rect.width, rect.height, rect.radius);
      }
    }

    const initSection = (root) => {
      if (!root || instances.has(root)) return;
      const instance = new ThreeStateScroll(root);
      instances.set(root, instance);

      if (window.Shopify && window.Shopify.designMode) {
        instance.connect();
        return;
      }

      if ('IntersectionObserver' in window) {
        const lazyRootMargin = window.matchMedia('(max-width: 749px)').matches ? '720px 0px' : '900px 0px';

        instance.lazyObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            if (instance.lazyObserver) {
              instance.lazyObserver.disconnect();
              instance.lazyObserver = null;
            }
            instance.connect();
          });
        }, { rootMargin: lazyRootMargin });
        instance.lazyObserver.observe(root);
        return;
      }

      instance.connect();
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll(SELECTOR).forEach(initSection);
    };

    document.addEventListener('DOMContentLoaded', () => initAll());

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(SELECTOR).forEach((root) => {
        const instance = instances.get(root);
        if (!instance) return;
        instance.disconnect();
        instances.delete(root);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["water-depth-scroll"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const controllerKey = 'waterDepthScrollControllerClean';

    if (window[controllerKey]) {
      window[controllerKey].initAll(document);
      return;
    }

    const states = new WeakMap();
    const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
    const smoothstep = (start, end, value) => {
      if (start === end) return value >= end ? 1 : 0;
      const progress = clamp((value - start) / (end - start));
      return progress * progress * (3 - 2 * progress);
    };

    const parseConfig = (section) => {
      const configEl = section.querySelector('[data-water-depth-config]');
      if (!configEl) return { frames: [], minDepth: 3, maxDepth: 10, unitLabel: 'ATM', steps: [] };

      try {
        return JSON.parse(configEl.textContent || '{}');
      } catch (error) {
        return { frames: [], minDepth: 3, maxDepth: 10, unitLabel: 'ATM', steps: [] };
      }
    };

    const fitCover = (image, canvasWidth, canvasHeight, focusX, focusY) => {
      const imageWidth = image.naturalWidth || image.width || canvasWidth;
      const imageHeight = image.naturalHeight || image.height || canvasHeight;
      const scale = Math.max(canvasWidth / imageWidth, canvasHeight / imageHeight);
      const width = imageWidth * scale;
      const height = imageHeight * scale;
      const x = (canvasWidth - width) * clamp(focusX);
      const y = (canvasHeight - height) * clamp(focusY);

      return { x, y, width, height };
    };

    const resizeCanvas = (state) => {
      const rect = state.canvas.getBoundingClientRect();
      const ratio = Math.min(window.devicePixelRatio || 1, window.innerWidth < 750 ? 1.35 : 1.75);
      const width = Math.max(1, Math.round(rect.width * ratio));
      const height = Math.max(1, Math.round(rect.height * ratio));

      if (state.canvas.width !== width || state.canvas.height !== height) {
        state.canvas.width = width;
        state.canvas.height = height;
        state.drawnIndex = -1;
      }
    };

    const drawFrame = (state, index) => {
      if (!state.canvas || !state.ctx) return;

      const frame = state.images[index] || state.lastImage;
      if (!frame || !frame.complete) return;

      resizeCanvas(state);

      const box = fitCover(
        frame,
        state.canvas.width,
        state.canvas.height,
        state.config.focusX || 0.5,
        state.config.focusY || 0.5
      );

      state.ctx.clearRect(0, 0, state.canvas.width, state.canvas.height);
      state.ctx.drawImage(frame, box.x, box.y, box.width, box.height);
      state.lastImage = frame;
      state.drawnIndex = index;
      state.section.classList.add('is-canvas-ready');
    };

    const loadFrame = (state, index) => {
      if (index < 0 || index >= state.config.frames.length) return;
      if (state.images[index] || state.loading[index]) return;

      const image = new Image();
      state.loading[index] = true;
      image.decoding = 'async';
      image.onload = () => {
        state.images[index] = image;
        state.loading[index] = false;
        state.lastImage = state.lastImage || image;

        if (index === state.targetIndex || state.drawnIndex < 0) {
          drawFrame(state, state.targetIndex);
        }
      };
      image.onerror = () => {
        state.loading[index] = false;
      };
      image.src = state.config.frames[index];
    };

    const warmFrames = (state, index) => {
      if (!state.useFrames || !state.config.frames.length) return;

      const radius = window.innerWidth < 750 ? 2 : 4;
      loadFrame(state, index);

      for (let offset = 1; offset <= radius; offset += 1) {
        loadFrame(state, index - offset);
        loadFrame(state, index + offset);
      }
    };

    const setActiveStep = (state, depth) => {
      const active = state.steps.reduce((match, step) => {
        if (depth >= Number(step.depth)) return step;
        return match;
      }, state.steps[0] || null);

      if (!active || state.activeDepth === active.depth) return;

      state.activeDepth = active.depth;

      const fallbackLabel = `${active.depth} ${state.unitLabel || ''}`.trim();

      if (state.currentDepth) state.currentDepth.textContent = active.label || fallbackLabel;
      if (state.currentTitle) state.currentTitle.textContent = active.title || '';
      if (state.currentText) state.currentText.textContent = active.text || '';

      state.stepEls.forEach((stepEl) => {
        stepEl.classList.toggle('is-active', Number(stepEl.dataset.waterDepthStep) === Number(active.depth));
      });
    };

    const syncVideo = (state, progress) => {
      if (!state.video || state.useFrames) return;
      if (!Number.isFinite(state.video.duration) || state.video.duration <= 0) return;

      const targetTime = progress * state.video.duration;
      if (Math.abs(state.video.currentTime - targetTime) > 0.08) {
        state.video.currentTime = targetTime;
      }
    };

    const hydrateVideo = (state) => {
      if (!state.video || state.video.dataset.waterDepthVideoHydrated === 'true') return;

      const sources = Array.from(state.video.querySelectorAll('[data-water-depth-video-src]'));
      sources.forEach((source) => {
        if (source.src || !source.dataset.waterDepthVideoSrc) return;
        source.src = source.dataset.waterDepthVideoSrc;
      });

      if (!sources.length) return;

      state.video.dataset.waterDepthVideoHydrated = 'true';
      state.video.preload = 'metadata';
      state.video.load();
    };

    const updateSection = (section) => {
      const state = states.get(section);
      if (!state || !section.isConnected) return;

      const rect = section.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
      const isNearViewport = rect.bottom > -240 && rect.top < viewportHeight + 240;
      const travel = Math.max(section.offsetHeight - viewportHeight, 1);
      const raw = clamp(-rect.top / travel);
      const progress = smoothstep(0, 1, raw);
      const depthRange = Math.max(state.maxDepth - state.minDepth, 0);
      const depth = Math.round(state.minDepth + progress * depthRange);

      section.style.setProperty('--water-depth-progress', progress.toFixed(4));
      section.style.setProperty('--water-depth-fill', `${(progress * 100).toFixed(2)}%`);
      section.style.setProperty('--water-depth-level', `${((1 - progress) * 100).toFixed(2)}%`);
      section.classList.toggle('is-complete', progress > 0.985);

      if (depth !== state.renderedDepth) {
        state.valueEl.textContent = String(depth);
        state.renderedDepth = depth;
        setActiveStep(state, depth);
      }

      if (state.useFrames && state.config.frames.length && isNearViewport) {
        const frameIndex = Math.round(progress * (state.config.frames.length - 1));
        state.targetIndex = frameIndex;
        warmFrames(state, frameIndex);
        drawFrame(state, frameIndex);
      }

      syncVideo(state, progress);
    };

    const requestUpdate = (section) => {
      const state = states.get(section);
      if (!state || state.ticking) return;

      state.ticking = true;
      window.requestAnimationFrame(() => {
        state.ticking = false;
        updateSection(section);
      });
    };

    const initSection = (section) => {
      if (!section || states.has(section)) return;

      const canvas = section.querySelector('[data-water-depth-canvas]');
      const valueEl = section.querySelector('[data-water-depth-value]');
      const config = parseConfig(section);
      const firstStepDepth = Array.isArray(config.steps) && config.steps.length ? Number(config.steps[0].depth) : 0;

      if (!canvas || !valueEl) return;

      const state = {
        section,
        canvas,
        ctx: canvas.getContext('2d', { alpha: false }),
        valueEl,
        currentDepth: section.querySelector('[data-water-depth-current-depth]'),
        currentTitle: section.querySelector('[data-water-depth-current-title]'),
        currentText: section.querySelector('[data-water-depth-current-text]'),
        stepEls: Array.from(section.querySelectorAll('[data-water-depth-step]')),
        video: section.querySelector('video'),
        config,
        steps: Array.isArray(config.steps) ? config.steps : [],
        minDepth: Number(config.minDepth) || firstStepDepth || 0,
        maxDepth: Number(config.maxDepth) || 10,
        unitLabel: config.unitLabel || 'ATM',
        images: [],
        loading: [],
        lastImage: null,
        drawnIndex: -1,
        targetIndex: 0,
        renderedDepth: -1,
        activeDepth: null,
        ticking: false,
        preloadStarted: false,
        useFrames: section.dataset.useFrames === 'true'
      };

      states.set(section, state);

      if (state.video) {
        state.video.muted = true;
        state.video.defaultMuted = true;
        state.video.setAttribute('muted', 'muted');
        state.video.setAttribute('playsinline', 'playsinline');
        state.video.setAttribute('webkit-playsinline', '');
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (state.useFrames) {
              warmFrames(state, state.targetIndex);
            } else {
              hydrateVideo(state);
            }
            requestUpdate(section);
          }
        });
      }, { rootMargin: '220px 0px' });

      observer.observe(section);
      state.observer = observer;

      updateSection(section);
    };

    const destroySection = (section) => {
      const state = states.get(section);
      if (!state) return;

      if (state.observer) state.observer.disconnect();
      states.delete(section);
    };

    const initAll = (root = document) => {
      if (root.matches && root.matches('[data-water-depth-scroll]')) initSection(root);
      root.querySelectorAll('[data-water-depth-scroll]').forEach(initSection);
    };

    const updateAll = () => {
      document.querySelectorAll('[data-water-depth-scroll]').forEach(requestUpdate);
    };

    window[controllerKey] = { initAll, updateAll, destroySection };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
    } else {
      initAll(document);
    }

    window.addEventListener('scroll', updateAll, { passive: true });
    document.addEventListener('scroll', updateAll, { passive: true, capture: true });
    window.addEventListener('resize', updateAll);
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:select', (event) => {
      initAll(event.target);
      updateAll();
    });
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.matches && event.target.matches('[data-water-depth-scroll]')) {
        destroySection(event.target);
      }

      event.target.querySelectorAll('[data-water-depth-scroll]').forEach(destroySection);
    });

    window.setTimeout(updateAll, 80);
    window.setTimeout(updateAll, 360);
  })();

  } catch(e) { console.error(e); }
})();
})();
